var paragraph_default = {
  "fontElementMap": "A-Jtb",
  "elementSpacing": "kjztB",
  "text": "SpiL2 kjztB",
  "child": "G7Gjj"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
